export const SYNC_DATA_MUTATION_KEY = ['syncDataMutation'];
export const PPL_ERROR_MESSAGE = 'PPL has detected errors. Please correct these issues and try again.';
